@if (crumbs().length > 0) {
  <nav class="nepf-breadcrumbs" aria-label="Breadcrumb">
    <ol>
      <li class="bc-item">
        <a routerLink="/" aria-label="Home">
          <mat-icon aria-hidden="true" class="bc-home-icon">home</mat-icon>
        </a>
      </li>
      @for (c of crumbs(); track c.label + ':' + (c.url || '$')) {
        <li class="bc-sep" aria-hidden="true">
          <mat-icon class="bc-sep-icon">chevron_right</mat-icon>
        </li>
        <li class="bc-item">
          @if (c.url) {
            <a [routerLink]="c.url">{{ c.label }}</a>
          } @else {
            <span aria-current="page">{{ c.label }}</span>
          }
        </li>
      }
    </ol>
  </nav>
}
